import { render, staticRenderFns } from "./postRow.vue?vue&type=template&id=02396814&"
import script from "./postRow.vue?vue&type=script&lang=js&"
export * from "./postRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports